import produce from "../util/produce";

export const initialState = {
  loadApplicationLoading: false,
  loadApplicationDone: false,
  loadApplicationError: null,
  loadAllApplicationsLoading: false,
  loadAllApplicationsDone: false,
  loadAllApplicationsError: null,
  loadAppliedListsLoading: false,
  loadAppliedListsDone: false,
  loadAppliedListsError: null,
  loadRecruitmentLoading: false,
  loadRecruitmentDone: false,
  loadRecruitmentError: null,
  loadMatchingListsLoading: false,
  loadMatchingListsDone: false,
  loadMatchingListsError: null,
  deleteMatchingListLoading: false,
  deleteMatchingListDone: false,
  deleteMatchingListError: null,
  addMatchingListLoading: false,
  addMatchingListDone: false,
  addMatchingListError: null,
  application: null,
  allApplications: null,
  appliedLists: null,
  matchingLists: [],
  recruitment: null,
};

export const LOAD_APPLICATION_REQUEST = "LOAD_APPLICATION_REQUEST";
export const LOAD_APPLICATION_SUCCESS = "LOAD_APPLICATION_SUCCESS";
export const LOAD_APPLICATION_FAILURE = "LOAD_APPLICATION_FAILURE";

export const LOAD_ALLAPPLICATIONS_REQUEST = "LOAD_ALLAPPLICATIONS_REQUEST";
export const LOAD_ALLAPPLICATIONS_SUCCESS = "LOAD_ALLAPPLICATIONS_SUCCESS";
export const LOAD_ALLAPPLICATIONS_FAILURE = "LOAD_ALLAPPLICATIONS_FAILURE";

export const LOAD_APPLIEDLISTS_REQUEST = "LOAD_APPLIEDLISTS_REQUEST";
export const LOAD_APPLIEDLISTS_SUCCESS = "LOAD_APPLIEDLISTS_SUCCESS";
export const LOAD_APPLIEDLISTS_FAILURE = "LOAD_APPLIEDLISTS_FAILURE";

export const LOAD_MATCHINGLISTS_REQUEST = "LOAD_MATCHINGLISTS_REQUEST";
export const LOAD_MATCHINGLISTS_SUCCESS = "LOAD_MATCHINGLISTS_SUCCESS";
export const LOAD_MATCHINGLISTS_FAILURE = "LOAD_MATCHINGLISTS_FAILURE";

export const DELETE_MATCHINGLIST_REQUEST = "DELETE_MATCHINGLIST_REQUEST";
export const DELETE_MATCHINGLIST_SUCCESS = "DELETE_MATCHINGLIST_SUCCESS";
export const DELETE_MATCHINGLIST_FAILURE = "DELETE_MATCHINGLIST_FAILURE";

export const ADD_MATCHINGLIST_REQUEST = "ADD_MATCHINGLIST_REQUEST";
export const ADD_MATCHINGLIST_SUCCESS = "ADD_MATCHINGLIST_SUCCESS";
export const ADD_MATCHINGLIST_FAILURE = "ADD_MATCHINGLIST_FAILURE";

export const LOAD_RECRUITMENT_REQUEST = "LOAD_RECRUITMENT_REQUEST";
export const LOAD_RECRUITMENT_SUCCESS = "LOAD_RECRUITMENT_SUCCESS";
export const LOAD_RECRUITMENT_FAILURE = "LOAD_RECRUITMENT_FAILURE";

const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case LOAD_APPLICATION_REQUEST:
        draft.loadApplicationLoading = true;
        draft.loadApplicationError = null;
        draft.loadApplicationDone = false;
        break;
      case LOAD_APPLICATION_SUCCESS:
        draft.loadApplicationLoading = false;
        draft.application = action.data;
        draft.loadApplicationDone = true;
        break;
      case LOAD_APPLICATION_FAILURE:
        draft.loadApplicationLoading = false;
        draft.loadApplicationError = action.error;
        break;
      case LOAD_ALLAPPLICATIONS_REQUEST:
        draft.loadAllApplicationsLoading = true;
        draft.loadAllApplicationsError = null;
        draft.loadAllApplicationsDone = false;
        break;
      case LOAD_ALLAPPLICATIONS_SUCCESS:
        draft.loadAllApplicationsLoading = false;
        draft.allApplications = action.data;
        draft.loadAllApplicationsDone = true;
        break;
      case LOAD_ALLAPPLICATIONS_FAILURE:
        draft.loadAllApplicationsLoading = false;
        draft.loadAllApplicationsError = action.error;
        break;
      case LOAD_APPLIEDLISTS_REQUEST:
        draft.loadAppliedListsLoading = true;
        draft.loadAppliedListsError = null;
        draft.loadAppliedListsDone = false;
        break;
      case LOAD_APPLIEDLISTS_SUCCESS:
        draft.loadAppliedListsLoading = false;
        draft.appliedLists = action.data;
        draft.loadAppliedListsDone = true;
        break;
      case LOAD_APPLIEDLISTS_FAILURE:
        draft.loadAppliedListsLoading = false;
        draft.loadAppliedListsError = action.error;
        break;
      case LOAD_MATCHINGLISTS_REQUEST:
        draft.loadMatchingListsLoading = true;
        draft.loadMatchingListsError = null;
        draft.loadMatchingListsDone = false;
        break;
      case LOAD_MATCHINGLISTS_SUCCESS:
        draft.loadMatchingListsLoading = false;
        // 예전엔 새로 불러온 목록을 기존 목록 뒤에 이어 붙였습니다(concat).
        // 상세 진행사항 화면이 8초마다 조용히 다시 불러오도록 바꾼 뒤로는,
        // 이 방식 때문에 화면에 표시되는 값이 "맨 처음 불러온 값"에 계속
        // 고정되고(같은 id의 첫 번째 항목만 씀), 실제로는 동의 상태가
        // 바뀌어도 반영되지 않았습니다. 매번 새로 받은 값으로 통째로
        // 바꿔치기하도록 고쳤습니다.
        draft.matchingLists = action.data;
        draft.loadMatchingListsDone = true;
        break;
      case LOAD_MATCHINGLISTS_FAILURE:
        draft.loadMatchingListsLoading = false;
        draft.loadMatchingListsError = action.error;
        break;
      case DELETE_MATCHINGLIST_REQUEST:
        draft.deleteMatchingListLoading = true;
        draft.deleteMatchingListDone = false;
        draft.deleteMatchingListError = null;
        break;
      case DELETE_MATCHINGLIST_SUCCESS:
        draft.deleteMatchingListLoading = false;
        draft.deleteMatchingListDone = true;
        draft.matchingLists = draft.matchingLists.filter(
          (item) => item.id !== action.data.id
        );
        break;
      case DELETE_MATCHINGLIST_FAILURE:
        draft.deleteMatchingListLoading = false;
        draft.deleteMatchingListError = action.error;
        break;
      case ADD_MATCHINGLIST_REQUEST:
        draft.addMatchingListLoading = true;
        draft.addMatchingListDone = false;
        draft.addMatchingListError = null;
        break;
      case ADD_MATCHINGLIST_SUCCESS:
        draft.addMatchingListLoading = false;
        draft.addMatchingListDone = true;
        // 서버는 "added"라는 짧은 글자만 돌려주는데, 예전엔 그 글자를
        // 매칭 목록에 그대로 이어 붙이고 있었습니다(목록이 망가짐).
        // 목록은 곧 다시 불러오므로 여기서는 손대지 않습니다.
        break;
      case ADD_MATCHINGLIST_FAILURE:
        draft.addMatchingListLoading = false;
        draft.addMatchingListError = action.error;
        break;
      case LOAD_RECRUITMENT_REQUEST:
        draft.loadRecruitmentLoading = true;
        draft.loadRecruitmentError = null;
        draft.loadRecruitmentDone = false;
        break;
      case LOAD_RECRUITMENT_SUCCESS:
        draft.loadRecruitmentLoading = false;
        draft.recruitment = action.data;
        draft.loadRecruitmentDone = true;
        break;
      case LOAD_RECRUITMENT_FAILURE:
        draft.loadRecruitmentLoading = false;
        draft.loadRecruitmentError = action.error;
        break;
      default:
        return state;
    }
  });
};

export default reducer;
